import { createSlice } from "@reduxjs/toolkit";
import { deleteState, getState, undoDeleteState } from "./state.api";

const stateSlice = createSlice({
  name: "state",
  initialState: {
    state: [],
    loading: false,
    error: null,
    success: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalData: 0,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    },
    updateLocalOrder: (state, action) => {
      state.state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getState.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getState.fulfilled, (state, action) => {
      state.loading = false;
      state.state = action.payload;
      state.dataLimit = action.payload.meta.limit;
      state.currentPage = action.payload.meta.page;
      state.totalPages = action.payload.meta.totalPages;
      state.totalData = action.payload.meta.total;
    });
    builder.addCase(getState.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(deleteState.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteState.fulfilled, (state, action) => {
      const deletedId = action.payload.data._id;

      if (state.state.data) {
        state.state.data = state.state.data.filter((state) => {
          return state._id !== deletedId;
        });
        state.loading = false;
      } else {
        console.error("state.state.data is not an array:", state.state.data);
      }
      state.loading = false;
    });
    builder.addCase(deleteState.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(undoDeleteState.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(undoDeleteState.fulfilled, (state, action) => {
      const undodeletedId = action.payload.data._id;

      if (state.state.data) {
        state.state.data = state.state.data.filter((state) => {
          return state._id !== undodeletedId;
        });
        state.loading = false;
      } else {
        console.error("state.state.data is not an array:", state.state.data);
      }
      state.loading = false;
    });
    builder.addCase(undoDeleteState.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { resetState } = stateSlice.actions;
export default stateSlice.reducer;
